import { NotificationsStack, useNotificationsContext } from 'pvs-design-system';
import React from 'react';

type AlertSeverity = 'success' | 'warning' | 'info' | 'error';

let notificationsContext: ReturnType<typeof useNotificationsContext>;

export const Notifications: React.FC = () => {
  notificationsContext = useNotificationsContext();
  return <NotificationsStack maxDisplayed={3} />;
};

const notify = (severity: AlertSeverity, message: string | React.ReactNode) => {
  if (!notificationsContext) return;
  notificationsContext.addNotification({
    severity,
    children: message,
  });
};

export const Notify = {
  success(message: string | React.ReactNode) {
    notify('success', message);
  },
  warning(message: string | React.ReactNode) {
    notify('warning', message);
  },
  info(message: string | React.ReactNode) {
    notify('info', message);
  },
  error(message: string | React.ReactNode) {
    notify('error', message);
  },
};

export default Notifications;
